/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ApptTypes/view.blocks to change it.
import React from 'react'
import SetupAction from './SetupAction/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ApptTypes({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Onboarding/ApptTypes"
  
}) {
  return (<React.Fragment
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h2"
 text="Appointment Types"
/>
<div
  data-testid="ApptTypes.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="ApptTypes.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="(Appointment Types are applied at Parent Company level)"
 fontStyle="italic"
/>
</div>
<div
  data-testid="ApptTypes.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<SetupAction
  viewPath={`${viewPath}/SetupAction`}
/>
</div>
</div>
{children}
</React.Fragment>)
}